<template>
  <v-container grid-list-xs fluid>
    <my-test :level="level" ctrl="liweiffffffff"></my-test>
    <!-- <v-btn color="success" @click="test">测试</v-btn>
    <gh-invoke v-model="data" module="mes.business.mdl.structure.service" cls="StructureService"
      method="custom_conditions_query" :args="{}" @start="" @complete="">
      <template v-slot="{args,data,loading}">
        <gh-diagram type="tree" ref="diagram"></gh-diagram>
      </template>
    </gh-invoke>
    <gh-range :range="range"></gh-range> -->
  </v-container>


</template>

<style scoped>

</style>

<script>
  import Test from "./test.ts";
  export default Test;
</script>